import { useQuery } from "@apollo/react-hooks";

import { Instructor } from "@hubcapp/types";

import GetInstructorArrears from "../graph-ql/getInstructorArrears.graphql";

const useQueryInstructorArrears = (id: string | undefined) =>
  useQuery<{
    instructor: Pick<Instructor, "arrears">;
  }>(GetInstructorArrears, {
    variables: {
      id,
    },
    skip: !id || id === "",
  });

export default useQueryInstructorArrears;
